module.exports = __webpack_public_path__ + "img/product-bg.b5ec1463.png";